"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTouchScreen = void 0;
const isTouchScreen = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 ||
  //@ts-ignore
  navigator.msMaxTouchPoints > 0;
};
exports.isTouchScreen = isTouchScreen;